'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryHelper = retryHelper;

var _eventBusRx = require('event-bus-rx');

var _eventBusRx2 = _interopRequireDefault(_eventBusRx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} topic A stream topic name.
 * @param {function} callback A data-fetching function, e.g., AthletesNoble.getProfile.
 * @param {object|null} The arguments for callback (possibly null).
 * @return {mixed} The message or error returned by callback().
 * @see FetchPeon.doDataFetch.
 */
function retryHelper(topic, callback, args) {
  function publishToTopic() {
    callback(args).subscribe(function (_) {
      return _eventBusRx2.default.publish(topic, _);
    });
  }

  var data = _eventBusRx2.default.getTopic(topic);
  _eventBusRx2.default.getTopic('retry-' + topic).subscribe(function (_) {
    return publishToTopic();
  });
  publishToTopic();
  return data;
}

// For testing
var RetryHelper = {
  retryHelper: retryHelper
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/helpers/RetryHelper.js
// module id = 102
// module chunks = 0